var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9376 12.4262V15.929C16.9403 16.1865 16.8872 16.4416 16.7819 16.6766C16.6766 16.9117 16.5216 17.1211 16.3277 17.2905C16.1337 17.4599 15.9053 17.5853 15.6582 17.658C15.4112 17.7307 15.1513 17.749 14.8965 17.7116C11.3642 17.2579 8.08329 15.6417 5.57072 13.1179C3.05815 10.594 1.45675 7.30587 1.01884 3.77159C0.981606 3.51752 0.999698 3.25841 1.07188 3.01198C1.14406 2.76555 1.26863 2.53763 1.43706 2.34381C1.6055 2.14998 1.81381 1.99483 2.04776 1.88898C2.28171 1.78313 2.53577 1.72907 2.79254 1.7305H6.2419C6.46224 1.72916 6.67527 1.80949 6.83987 1.95598C7.00447 2.10248 7.10897 2.30475 7.1332 2.52376C7.22165 3.69188 7.52376 4.83385 8.02451 5.8929C8.11038 6.09346 8.1197 6.31856 8.0507 6.52554C7.98171 6.73252 7.8392 6.90701 7.65016 7.01594L6.88364 7.45268C6.77315 7.51345 6.67681 7.59697 6.60099 7.69772C6.52517 7.79847 6.47159 7.91417 6.44379 8.03716C6.41599 8.16015 6.41461 8.28764 6.43973 8.41121C6.46484 8.53478 6.51589 8.65161 6.58951 8.75399C7.4713 10.0457 8.58676 11.1611 9.87843 12.0429C9.9808 12.1165 10.0976 12.1676 10.2212 12.1927C10.3448 12.2178 10.4723 12.2164 10.5953 12.1886C10.7182 12.1608 10.8339 12.1072 10.9347 12.0314C11.0354 11.9556 11.119 11.8593 11.1797 11.7488L11.6165 10.9823C11.7319 10.7907 11.9151 10.6496 12.1298 10.5869C12.3444 10.5241 12.5748 10.5444 12.7752 10.6436C13.8342 11.1443 14.9762 11.4464 16.1443 11.5349C16.3633 11.5591 16.5656 11.6636 16.7121 11.8282C16.8586 11.9928 16.9389 12.2058 16.9376 12.4262Z",
    stroke: "url(#paint0_linear_231_14447)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_14447",
    x1: 9,
    y1: 9.73047,
    x2: 8.96884,
    y2: 17.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phoneNumber.48a173f51f61d751fa7baff5e1b4591c.svg";
export { ForwardRef as ReactComponent };